(function () {
  var FREE_GIFT_VARIANTS = [
    56055958208838, // eBook
    56759731978566  // Gratis Oordopjes - Abonnement Cadeau
  ];

  var MAX_ONE_VARIANTS = [
    56759929176390  // RestUp Oordopjes (Gratis) - max 1 per bestelling
  ];

  var GIFT_PROP = '_free_gift';
  var syncing = false;
  var syncTimer = null;
  var silentAdd = false;

  // Suppress cart_changed during silent gift adds so UpCart doesn't open
  var _origDispatch = window.dispatchEvent.bind(window);
  window.dispatchEvent = function (evt) {
    if (silentAdd && evt.type === 'cart_changed') return;
    return _origDispatch(evt);
  };

  window.__restupGifts = { runs: 0, lastRun: null, lastResult: null, lastError: null };

  function fetchCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function notifyUpCart() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function hasSubscription(cart) {
    return cart.items.some(function (item) {
      if (item.selling_plan_allocation != null) return true;
      if (item.selling_plan != null) return true;
      if (item.properties && item.properties._selling_plan_id && item.properties._selling_plan_id !== '') return true;
      return false;
    });
  }

  function isVariantInCart(cart, variantId) {
    return cart.items.some(function (item) { return item.variant_id === variantId; });
  }

  function getScriptGiftKeys(cart) {
    return cart.items
      .filter(function (item) {
        return item.properties && item.properties[GIFT_PROP] === 'true';
      })
      .map(function (item) { return item.key; });
  }

  function syncNow() {
    if (syncing) return;
    syncing = true;

    fetchCart()
      .then(function (cart) {
        var overQty = {};
        cart.items.forEach(function (item) {
          if (MAX_ONE_VARIANTS.indexOf(item.variant_id) !== -1 && item.quantity > 1) {
            overQty[item.key] = 1;
          }
        });
        if (Object.keys(overQty).length > 0) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: overQty })
          }).then(function () { notifyUpCart(); return fetchCart(); });
        }
        return cart;
      })
      .then(function (cart) {
        var hasSub = hasSubscription(cart);
        var missing = [];

        window.__restupGifts.runs++;
        window.__restupGifts.lastRun = new Date().toISOString();
        window.__restupGifts.itemCount = cart.item_count;
        window.__restupGifts.hasSub = hasSub;

        if (hasSub) {
          missing = FREE_GIFT_VARIANTS.filter(function (id) {
            return !isVariantInCart(cart, id);
          });
          window.__restupGifts.missing = missing;

          if (missing.length === 0) {
            window.__restupGifts.lastResult = 'all_present';
            return Promise.resolve();
          }

          var items = missing.map(function (id) {
            return { id: id, quantity: 1, properties: { [GIFT_PROP]: 'true' } };
          });

          silentAdd = true;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (response) {
            return response.json().then(function (data) {
              if (response.ok) {
                window.__restupGifts.lastResult = 'added_ok';
                window.__restupGifts.addedData = data;
                notifyUpCart();
              } else {
                window.__restupGifts.lastResult = 'add_failed_' + response.status;
                window.__restupGifts.errorData = data;
              }
            });
          }).finally(function () {
            setTimeout(function () { silentAdd = false; }, 1500);
          });

        } else {
          var keysToRemove = getScriptGiftKeys(cart);
          window.__restupGifts.lastResult = 'no_sub_keys_' + keysToRemove.length;
          if (keysToRemove.length === 0) return Promise.resolve();

          var updates = {};
          keysToRemove.forEach(function (key) { updates[key] = 0; });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () { notifyUpCart(); });
        }
      })
      .catch(function (e) {
        window.__restupGifts.lastError = e.message;
      })
      .finally(function () { syncing = false; });
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncNow, 500);
  }

  function init() {
    syncNow();
    setInterval(syncNow, 3000);

    if (window.PerformanceObserver) {
      try {
        var cartObserver = new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            var isFetch = entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest';
            var isCart = /\/cart\//.test(entry.name);
            if (isFetch && isCart && !syncing) scheduleSync();
          });
        });
        cartObserver.observe({ entryTypes: ['resource'] });
      } catch (e) {}
    }

    window.addEventListener('cart_changed', function () { if (!syncing) scheduleSync(); });
    document.addEventListener('cart:updated', function () { if (!syncing) scheduleSync(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
